import "./NarrationWaveform.css";

export default function NarrationWaveform({ animated = false }) {
  return (
    <span
      className={`narration-waveform${animated ? " is-playing" : ""}`}
      aria-hidden="true"
    >
      <span />
      <span />
      <span />
      <span />
      <span />
    </span>
  );
}
